var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imgUrl),expression:"imgUrl"}],attrs:{"alt":"CarFinance247 Logo","width":"120"}})
}
var staticRenderFns = []

export { render, staticRenderFns }